import { useEffect, useState } from "react";
import CustomCommonModal from "../../../../../../../components/modal/common/v1/CustomCommonModal";
import useRouterHookV2 from "../../../../../../../hooks/router/useRouterHookV2";
import { dateToYYYYMMDD, getEndDate, getStartDate } from "../../../../../../../utils/dateFormatUtils";
import { Container } from "./styles/UnsalesItemViewSelector.styled";
import SelectorBoxFieldView from "./view/SelectorBoxField.view";
import { useApiHook } from "./hooks/useApiHook";
import { useSelector } from "react-redux";
import useErpItemCountHook from "./hooks/useErpItemCountHook";

const MAIN_CLIENT_ORIGIN = process.env.REACT_APP_MAIN_CLIENT_ADDRESS;

export default function UnsalesItemViewSelectorModalComponent(props) {
    const router = useRouterHookV2();
    const workspaceRedux = useSelector(state => state.workspaceRedux);
    const wsId = workspaceRedux?.workspaceInfo?.id;

    const { onReqSearchItemCount } = useApiHook();
    const { orderItemCount, holdItemCount, onSetOrderItemCount, onSetHoldItemCount } = useErpItemCountHook();

    useEffect(() => {
        async function fetchInit() {
            handleSearchOrderItemCount();
            handleSearchHoldItemCount();
        }

        if(!wsId) {
            return;
        }

        if(!props.unsalesItemSearchPeriod) {
            return;
        }

        fetchInit();
    }, [wsId, props.unsalesItemSearchPeriod])
    
    const handleActionRouteToPage = (pathname) => {
        let periodType = router.query.periodType === 'channelOrderDate' ? router.query.periodType : 'createdAt';
        let periodSearchCondition = periodType;
        let startDateTime = dateToYYYYMMDD(props.unsalesItemSearchPeriod?.startDate);
        let endDateTime = dateToYYYYMMDD(props.unsalesItemSearchPeriod?.endDate);
        let matchedCode = 'releaseOptionCode';

        window.open(MAIN_CLIENT_ORIGIN + pathname + 
            `?periodSearchCondition=${periodSearchCondition}` + 
            `&startDateTime=${startDateTime}` + 
            `&endDateTime=${endDateTime}` + 
            `&matchedCode=${matchedCode}`, '_blank');
    }

    const handleSearchOrderItemCount = async () => {
        let periodType = router.query.periodType === 'channelOrderDate' ? router.query.periodType : 'createdAt';

        let salesYn = 'n';
        let releaseYn = 'n';
        let holdYn = 'n';
        let periodSearchCondition = periodType;
        let searchStartDate = props.unsalesItemSearchPeriod?.startDate;
        let searchEndDate = props.unsalesItemSearchPeriod?.endDate;
        let matchedCode = 'releaseOptionCode';

        let params = {
            salesYn,
            releaseYn,
            holdYn,
            periodSearchCondition,
            startDateTime: getStartDate(searchStartDate),
            endDateTime: getEndDate(searchEndDate),
            matchedCode
        }

        await onReqSearchItemCount({
            headers: { wsId: wsId },
            params
        }, {
            success: (results) => {
                onSetOrderItemCount(results.totalSize)
            }
        })
    }

    const handleSearchHoldItemCount = async () => {
        let periodType = router.query.periodType === 'channelOrderDate' ? router.query.periodType : 'createdAt';

        let salesYn = 'n';
        let releaseYn = 'n';
        let holdYn = 'y';
        let periodSearchCondition = periodType;
        let searchStartDate = props.unsalesItemSearchPeriod?.startDate;
        let searchEndDate = props.unsalesItemSearchPeriod?.endDate;
        let matchedCode = 'releaseOptionCode';

        let params = {
            salesYn,
            releaseYn,
            holdYn,
            periodSearchCondition,
            startDateTime: getStartDate(searchStartDate),
            endDateTime: getEndDate(searchEndDate),
            matchedCode
        }

        await onReqSearchItemCount({
            headers: { wsId: wsId },
            params
        }, {
            success: (results) => {
                onSetHoldItemCount(results.totalSize)
            }
        })
    }

    return (
        <CustomCommonModal
            open={props.modalOpen}
            title={'미출고 확인'}
            element={
                <Container>
                    <SelectorBoxFieldView
                        orderItemCount={orderItemCount}
                        holdItemCount={holdItemCount}
                        onActionRouteToPage={handleActionRouteToPage}
                    />
                </Container>
            }
            maxWidth={'xs'}

            onClose={() => props.onActionCloseModal()}
        />
    )
}